export default __webpack_public_path__ + "static/media/places.c9507159.mp4";